import Skeleton from '@mui/material/Skeleton';
import withCx, { CxProps } from 'fe-core/util/withCx';

export const SKELETON_LOADER_VARIANTS = ['circular', 'rectangular'] as const;

export type Variant = (typeof SKELETON_LOADER_VARIANTS)[number];

interface SkeletonLoaderProps {
  height: string | number;
  variant?: Variant;
  width: string | number;
  bradiusfull?: boolean;
  bradiusl?: boolean;
  bradiusm?: boolean;
  bradiuss?: boolean;
}

const SkeletonLoader = ({
  cx,
  height,
  variant = 'rectangular',
  width,
  bradiuss,
  bradiusm,
  bradiusl,
  bradiusfull,
}: SkeletonLoaderProps & CxProps) => (
  <Skeleton
    animation="wave"
    className={cx(variant, {
      bradiuss: !!bradiuss,
      bradiusm: !!bradiusm,
      bradiusl: !!bradiusl,
      bradiusfull: !!bradiusfull,
    })}
    variant={variant}
    width={width}
    height={height}
  />
);

export default withCx<SkeletonLoaderProps>('FDBSkeletonLoader')(SkeletonLoader);
